import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MainComponent } from '@commons/file-picker/main/main.component';
import { FileSizePipe } from '@commons/file-picker/pipes/file-size.pipe';
import { FileTypePipe } from '@commons/file-picker/pipes/file-type.pipe';
import { PlaceholderComponent } from '@commons/file-picker/placeholder/placeholder.component';
import { PreviewComponent } from '@commons/file-picker/preview/preview.component';
import { ProgressComponent } from '@commons/file-picker/progress/progress.component';
import { FILE_PICKER_UPLOAD_SERVICE_TOKEN } from '@commons/file-picker/services/file-picker-upload-service.token';
import { FileWebService } from '@commons/file-picker/services/file.web-service';
import { FileWebservice } from '@wizbii/webservices';

@NgModule({
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule],
  declarations: [FileSizePipe, FileTypePipe, MainComponent, PlaceholderComponent, PreviewComponent, ProgressComponent],
  providers: [FileWebservice, { provide: FILE_PICKER_UPLOAD_SERVICE_TOKEN, useClass: FileWebService }],
  exports: [MainComponent],
})
export class FilePickerModule {}
